module.exports = __webpack_public_path__ + "static/media/amusement.cab9f70a.jpg";